import Action from '../../../decorators/Action';
import Observable from '../../../decorators/Observable';
import StoreFieldInSession from '../../../decorators/StoreFieldInSession';
import AbstractSessionModel from '../../../models/AbstractSessionModel';

export default class BusinessWizardData extends AbstractSessionModel {
  @Observable()
  @StoreFieldInSession()
  public google_place_id: string = '';

  @Observable()
  @StoreFieldInSession()
  public company_name: string = '';

  @Observable()
  @StoreFieldInSession()
  public zip: string = '';

  @Observable()
  @StoreFieldInSession()
  public address: string = '';

  @Observable()
  @StoreFieldInSession()
  public street: string = '';

  @Observable()
  @StoreFieldInSession()
  public state: string = '';

  @Observable()
  @StoreFieldInSession()
  public city: string = '';

  @Observable()
  @StoreFieldInSession()
  public country: string = '';

  @Observable()
  @StoreFieldInSession()
  public phone: string = '';

  @Observable()
  @StoreFieldInSession()
  public website: string = '';

  @Observable()
  @StoreFieldInSession()
  public domain_type: string = '';

  @Observable()
  @StoreFieldInSession()
  public category: string = '';

  @Observable()
  @StoreFieldInSession()
  public openingHours: string[] = [];

  @Observable()
  @StoreFieldInSession()
  public openingHoursFormatted: {
    [key: string]: {
      fromTime: string;
      isClosed: boolean;
      toTime: string;
    }[];
  } = {};

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  setFormData(data: {
    company_name: string;
    zip: string;
    address: string;
    street: string;
    state: string;
    city: string;
    country: string;
    phone: string;
    website: string;
    domain_type: string;
    category: string;
    google_place_id: string;
    openingHours: string[];
    openingHoursFormatted: {
      [key: string]: {
        fromTime: string;
        isClosed: boolean;
        toTime: string;
      }[];
    };
  }) {
    this.company_name = data.company_name;
    this.zip = data.zip;
    this.address = data.address;
    this.street = data.street;
    this.state = data.state;
    this.city = data.city;
    this.country = data.country;
    this.phone = data.phone;
    this.website = data.website;
    this.domain_type = data.domain_type;
    this.category = data.category;
    this.google_place_id = data.google_place_id;
    this.openingHours = data.openingHours;
    this.openingHoursFormatted = data.openingHoursFormatted;
  }

  getWizardData() {
    return {
      company_name: this.company_name,
      zip: this.zip,
      address: this.address,
      street: this.street,
      state: this.state,
      city: this.city,
      country: this.country,
      phone: this.phone,
      website: this.website,
      domain_type: this.domain_type,
      category: this.category,
      opening_hours: this.openingHours,
      opening_hours_formatted: this.openingHoursFormatted
    };
  }

  getSessionKey(): string {
    return 'BusinessWizardData';
  }
}
